export default {"src":"/_next/static/media/s8.3-shipping-restrictions.44333bc2.svg","height":46,"width":46,"blurWidth":0,"blurHeight":0};